<template>
    <div class="bodys">
        <Header></Header>
        <div>
            <router-view/>
            <bubble-area/>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from './UI/Header';
    import Footer from './UI/Footer';
    import BubbleArea from './UI/BubbleArea';

    export default {
        name: "Index",
        components: {
            Header,
            Footer,
            BubbleArea,
        },
        data() {
            return {
                observer: null, // 存储观察器实例
            }
        },
        mounted() {
            // 处理移动端导航交互
            const btnNavEl = document.querySelector(".btn-mobile-nav");
            const headerEl = document.querySelector("header");
            const htmlEl = document.querySelector("html");
            btnNavEl.addEventListener("click", () => {
                headerEl.classList.toggle("nav-open");
                htmlEl.classList.toggle("lock");
            });
            const mainNavLinks = document.querySelectorAll(".main-nav-link");
            mainNavLinks.forEach((mainNavLink) =>
                mainNavLink.addEventListener("click", () => {
                    if (headerEl.classList.contains("nav-open")) {
                        headerEl.classList.toggle("nav-open");
                        htmlEl.classList.toggle("lock");
                    }
                })
            );

            window.addEventListener('scroll', this.handleScroll);
        },
        beforeDestroy() {
            // 移除事件监听，避免内存泄漏
            window.removeEventListener('scroll', this.handleScroll);
        },
        methods: {
            // 处理滚动事件
            handleScroll() {
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                const sectionHeroEl = document.querySelector(".section-hero");

                // 安全检查：确保元素存在
                if (sectionHeroEl && scrollTop > sectionHeroEl.clientHeight) {
                    document.body.classList.add("sticky");
                } else {
                    document.body.classList.remove("sticky");
                }
            },
        },
    }
</script>

<style scoped lang="scss">

</style>
